export default {"src":"/_next/static/media/attract-new-carriers.f14a1042.svg","height":156,"width":151,"blurWidth":0,"blurHeight":0};